<p-menu
  [attr.data-testId]="dataTestId"
  [model]="items"
  [popup]="popup"
  appendTo="body"
></p-menu>
